import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import styled from 'styled-components/macro'
import { Banner } from './ProductAreaStyles'
import { BannerButtonWrapper, BannerWrapper } from '@/components/PageParts/HomeMain/MainStyles'
import Link from 'next/link'
import { Button } from '@/components/button'
import { device } from '@/utils/Theme'

const IndexProductArea: React.VFC = () => {
  const { t } = useTranslation('common')

  return (
    <Wrapper>
      <Column>
        <Link href="https://sintrasporteshop.sk/produkt/tenisky-hummel-algiz-iii-white/" passHref>
          <a href="#">
            <BannerWrapper>
              <Banner src="/images/banners/homepage-banner-4.jpg" />
            </BannerWrapper>
          </a>
        </Link>
        <Link href="https://sintrasporteshop.sk" passHref>
          <a href="#">
            <BannerWrapper>
              <Banner src="/images/banners/homepage-banner-7.jpg" />
            </BannerWrapper>
          </a>
        </Link>
      </Column>

      <Column>
        <Link href="https://sintrasporteshop.sk/kategoria-produktu/oblecenie/panske-oblecenie/panske-dresy/" passHref>
          <a href="#">
            <BannerWrapper>
              <Banner src="/images/banners/homepage-banner-2.jpg" />
            </BannerWrapper>
          </a>
        </Link>
        <Link href="/brand/cobra-puma-golf/" passHref>
          <a href="#">
            <BannerWrapper>
              <Banner src="/images/banners/homepage-banner-6.jpg" />
            </BannerWrapper>
          </a>
        </Link>
      </Column>
    </Wrapper>
  )
}

export default IndexProductArea

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: ${device.mobile}) {
    grid-template-columns: 1fr;
  }
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

